import { makeStyles } from "@material-ui/core/styles";
//import { blue } from "@material-ui/core/colors";
//import color from "@material-ui/core/colors/amber";

export default makeStyles((theme) => ({
	card: {
		minHeight: "100%",
		//display: "flex",
		flexDirection: "column",
		maxWidth: "100%",
		padding: "0",
	},
	GridContainer: {
		display: "inline-block",
	},
	visitsNumberContainer: {
		// display: "flex",
		alignItems: "center",
		flexGrow: 1,
		paddingBottom: theme.spacing(1),
	},
	progressSection: {
		// marginBottom: theme.spacing(1),
		display: "inline-block",
		flexDirection: "row",
		paddingRight: "0px",
		width: "100%",
		"&:nth-child(3)": {
			width: "10%",
		},
	},

	name: {
		paddingTop: "0",
	},

	ProgresSectionBar: {
		display: "inline-block",
	},
	RemainingWork: {
		color: "white",
		marginBottom: "15px",
	},
	ToggleBar: {
		padding: theme.spacing(1),
		display: "block",
		overflow: "auto",
		flexDirection: "column",
		// backgroundColor:'#4e80c5',
		"background-color": "#4e80c5",
	},
	progressTitle: {
		marginBottom: theme.spacing(1),
	},
	paper: {
		padding: theme.spacing(2),
		display: "flex",
		/*overflow: "auto",*/
		flexDirection: "column",
	},
	fixedHeight: {
		height: 209,
	},
	fullfixedHeight: {
		height: 355,
	},
	// rightfixedHeight: {
	//   height: 580,
	// },
	title: {
		display: "flex",
		flexDirection: "row",
		justifyContent: "space-between",
		// alignItems: "center",
		width: "100%",
		marginBottom: theme.spacing(1),
	},
	select: {
		backgroundColor: "white",
		marginLeft: "40px",
		width: "110px",
		height: "30px",
		color: "black",
		borderRadius: "7%",
		fontSize: "13px",
	},

	selectInput: {
		padding: 10,
		paddingRight: 25,
		"&:focus": {
			backgroundColor: "white",
		},
	},
	progress: {
		marginBottom: theme.spacing(1),
		//backgroundColor: theme.palette.warning.main,
	},
	pieChartLegendWrapper: {
		height: "100%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "flex-end",
		marginRight: theme.spacing(1),
	},
	legendItemContainer: {
		display: "flex",
		alignItems: "center",
		marginBottom: theme.spacing(1),
	},
	fullHeightBody: {
		display: "flex",
		flexGrow: 1,
		flexDirection: "column",
		justifyContent: "space-between",
	},
	tableWidget: {
		overflowX: "auto",
	},
	progressBar: {
		backgroundColor: theme.palette.success.main,
		color: "green",
	},
	performanceLegendWrapper: {
		display: "flex",
		flexGrow: 1,
		alignItems: "center",
		marginBottom: theme.spacing(1),
	},
	legendElement: {
		display: "flex",
		alignItems: "center",
		marginRight: theme.spacing(2),
	},
	legendElementText: {
		marginLeft: theme.spacing(1),
		color: "white",
	},
	serverOverviewElement: {
		display: "flex",
		alignItems: "center",
		maxWidth: "100%",
	},
	serverOverviewElementText: {
		minWidth: 145,
		paddingRight: theme.spacing(2),
	},
	serverOverviewElementChartWrapper: {
		width: "100%",
	},
	mainChartBody: {
		overflowX: "auto",
	},
	mainChartHeader: {
		width: "100%",
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		[theme.breakpoints.only("xs")]: {
			flexWrap: "wrap",
		},
	},
	mainChartHeaderLabels: {
		display: "flex",
		alignItems: "center",
		[theme.breakpoints.only("xs")]: {
			order: 3,
			width: "100%",
			justifyContent: "center",
			marginTop: theme.spacing(3),
			marginBottom: theme.spacing(2),
		},
	},
	mainChartHeaderLabel: {
		display: "flex",
		alignItems: "center",
		marginLeft: theme.spacing(3),
	},
	mainChartSelectRoot: {
		borderColor: theme.palette.text.hint + "80 !important",
	},
	mainChartSelect: {
		padding: 10,
		paddingRight: 25,
	},
	mainChartLegentElement: {
		fontSize: "18px !important",
		marginLeft: theme.spacing(1),
	},

	Button: {
		display: "flex",
		border: "none",
		color: "blue",
		backgroundColor: "aliceblue",
		verticalAlign: "middle",
		alignItems: "center",
		padding: "0px",
		outline: "none",
	},
	GridStatus: {
		display: "inline-block",
		maxWidth: "100%",
		padding: "0px",
		margin: "0",
	},
	Nodes: {
		display: "flex",
		justifyContent: "space-between",
	},
	// DayDropDown:{
	//   position:"absolute",
	//   right:"28px",
	//   top:"88px",
	//   color:"black",
	// },
	// DaySelect:{
	//   // backgroundColor: "white",
	//   marginLeft:"40px",
	//   width:"110px",
	//   height:"30px",
	//  color:"black",
	//  borderRadius:"7%",
	//  fontSize:"13px",
	//  border:"groove",
	//  borderWidth:"thin",
	//  borderColor:"lightgray",
	//  textDecoration:"none",
	// },
	transferButton: {
		backgroundColor: "transparent !important",
		boxShadow: "none",
		border: "none",
		textTransform: "capitalize",
		padding: "5px",
		textAlign: "left",
		display: "block",
		minWidth: "100%",
		"&:hover": {
			// backgroundColor:"transparent !important",
			boxShadow: "none",
			border: "none",
			padding: "5px",
			textAlign: "left",
			display: "block",
			minWidth: "100%",
		},
	},

	dialog: {
		width: "350px",
		margin: "0 auto",
	},
	dialogTital: {
		fontSize: "0.8rem",
		textAlign: "center",
		paddingTop: "20px",
		color: "#686D88",
	},
	avatar: {
		textAlign: "center",
		alignItems: "center",
		position: "absolute",
		right: "100px",
		paddingBottom: "30px",
	},
	callerName: {
		fontSize: "2rem",
		textAlign: "center",
		color: "#526FEB",
		paddingTop: "125px",
		paddingLeft: "27px",
	},
	callButton: {
		left: "73px",
		marginBottom: "30px",
		backgroundColor: "#FF3B30",
		color: "white",
		textTransform: "capitalize",
		height: "35px",
		width: "132px",
	},
}));
